"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationToken = void 0;
var shared_1 = require("@cian/peperrors/shared");
var CancellationToken = /** @class */ (function () {
    function CancellationToken() {
        var _this = this;
        this.canceled = false;
        this.promise = new Promise(function (resolve) {
            _this.resolve = resolve;
            _this.destroy = resolve;
        });
    }
    CancellationToken.prototype.cancel = function (error) {
        var err = error || new shared_1.HttpCancelError('Canceled HTTP Request', 'http-api.CancellationToken');
        this.canceled = true;
        this.reason = err;
        this.resolve(err);
    };
    CancellationToken.prototype.isCanceled = function () {
        return this.canceled;
    };
    CancellationToken.prototype.toPromise = function () {
        return this.promise;
    };
    return CancellationToken;
}());
exports.CancellationToken = CancellationToken;
//# sourceMappingURL=cancellationToken.js.map